// extracted by mini-css-extract-plugin
export default {"cls1":"ah9hryLgAp9KuXt72Zcz","cls2":"_IZUQe3z7IHdEj9NNOYk ah9hryLgAp9KuXt72Zcz","bookingAppRedesign":"wMyxOd1gm0uWsI5eW4g4"};